"use strict";
/*
 * Created on 28. 1. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * State of exported price list row.
 * @author Radek Beran
 */

var ExportedPriceListRowState;

(function (ExportedPriceListRowState) {
  /** Waiting for acceptance. */
  ExportedPriceListRowState["Waiting"] = "Waiting";
  /** Accepted (confirmed) by IDB. */

  ExportedPriceListRowState["Accepted"] = "Accepted";
  /** Export has finished with a failure. */

  ExportedPriceListRowState["Failed"] = "Failed";
})(ExportedPriceListRowState = exports.ExportedPriceListRowState || (exports.ExportedPriceListRowState = {}));